import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=283a4c7a&scoped=true&lang=pug"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=283a4c7a&prod&lang=sass"
import style1 from "./Settings.vue?vue&type=style&index=1&id=283a4c7a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a4c7a",
  null
  
)

export default component.exports